<template>
    <div class="profile__mobile calendar__mobile m-calendar">
        <calendar-mobile-header></calendar-mobile-header>
        <div class="m-calendar__time">
            <div class="m-calendar__timeheader">
                <span class="calendar__label">Время</span>
            </div>
            <calendar-mobile-cells></calendar-mobile-cells>
            <calendar-mobile-popup></calendar-mobile-popup>
        </div>
    </div>
</template>

<script>
    import CalendarMobileHeader from "./CalendarMobileHeader.vue";
	import CalendarMobileCells from "./CalendarMobileCells.vue";
	import CalendarMobilePopup from "./CalendarMobilePopup.vue";

	export default {
		name: 'CalendarMobile',
		components: {
			CalendarMobilePopup,
			CalendarMobileCells,
			CalendarMobileHeader
        },
    }
</script>


